import { Guid } from "./Guid";
import { ISecondScreenServiceComparableData } from "./ISecondScreenServiceComparableData";

class SecondScreenNoteData implements ISecondScreenServiceComparableData<SecondScreenNoteData> {
    public patientId: Guid;
    public encounterId?: string;
    public isEncounterDeleted?: boolean;
    public encounterFilterUnapprovedNotes?: boolean;
    public encounterFilterMyNotes?: boolean;
    public encounterFilterClinicVisitNotes?: boolean;

    public constructor(data: Partial<SecondScreenNoteData>) {
        Object.assign(this, data);
    }

    public isEqual(data: SecondScreenNoteData): boolean {
        return this.patientId === data.patientId &&
            this.isEncounterDeleted === data.isEncounterDeleted &&
            (this.encounterId === data.encounterId ||
                (this.encounterId && !data.encounterId));
    }
}

export { SecondScreenNoteData };
